import * as Sentry from "@sentry/react";

export async function apiFetch(url: string, options: { method?: string;[key: string]: any } = {}) {
    const start = performance.now();

    try {
        const response = await fetch(url, options);
        const duration = performance.now() - start;
        // SUCCESS → breadcrumb ringan saja
        if (response.ok) {
            Sentry.addBreadcrumb({
                category: "api",
                message: url,
                level: "info",
                data: {
                    method: options.method || "GET",
                    status: response.status,
                    duration,
                    response: sanitizeResponse(response.body)
                },
            });

            return response;
        }
        // ERROR (HTTP 4xx / 5xx)
        const errorData = await extractSafeBody(response);

        Sentry.withScope((scope) => {
            scope.setLevel("error");

            scope.setContext("api", {
                url,
                method: options.method || "GET",
                status: response.status,
                duration,
                response: sanitizeResponse(errorData),
                request: sanitizeRequest(options),
            });
            scope.setTag("endpoint", normalizeUrl(url));
            scope.setTag("method", options.method || "GET");
            scope.setTag("status", String(response.status));
            scope.setTag("status_group", `${Math.floor(response.status / 100)}xx`);
            Sentry.captureException(
                new Error(`API Error: ${options.method} ${normalizeUrl(url)} (${response.status})`)
            );
        });
        return response;
    } catch (error) {
        Sentry.withScope((scope) => {
            const method = options.method || "GET";

            scope.setLevel("error");

            scope.setTag("endpoint", normalizeUrl(url));
            scope.setTag("method", method);
            scope.setTag("status_group", "network_error");

            scope.setContext("api", {
                url,
                method,
                errorType: "network_error",
            });

            Sentry.captureException(error);
        });
        throw error;
    }
}
async function extractSafeBody(response: any) {
    try {
        const clone = response.clone();
        return await clone.json();
    } catch {
        return null;
    }
}
function sanitizeRequest(options: any) {
    if (!options) return null;

    const safe = { ...options };

    // header sensitif
    if (safe.headers?.Authorization) {
        safe.headers.Authorization = "***";
    }

    // body limit
    if (safe.body && typeof safe.body === "string") {
        safe.body = safe.body.slice(0, 500);
    }

    return safe;
}
function sanitizeResponse(data: any) {
    if (!data) return null;

    // contoh: buang field sensitif
    const cloned = { ...data };

    if (cloned.token) cloned.token = "***";
    if (cloned.password) cloned.password = "***";

    // limit size biar ga berat
    return JSON.stringify(cloned).slice(0, 500);
}
function normalizeUrl(url: string) {
    return url
        .replace(/\/\d+/g, "/:id")       // angka jadi :id
        .replace(/[?].*$/, "");          // hapus query param
}